import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Footer from '../../components/home/Footer';
import useAuthStore, { isTokenExpired } from '../../stores/authStore';
import { completePayment, getPaymentOrder } from './postJobApi';
import './PostJobWizard.css';

function PostJobSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { token, isAuthenticated } = useAuthStore();
  const orderId = searchParams.get('orderId');
  const mode = searchParams.get('mode') || '';
  const isFree = mode === 'free';
  const [status, setStatus] = useState(isFree ? 'review' : 'loading');
  const [jobTitle, setJobTitle] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const finalize = async () => {
      // Free plan: already submitted — show pending review (never payment messaging)
      if (isFree) {
        setStatus('review');
        if (!orderId || !isAuthenticated() || !token || isTokenExpired(token)) {
          return;
        }
        try {
          const orderRes = await getPaymentOrder(token, orderId);
          setJobTitle(orderRes.order?.jobPostingId?.title || '');
        } catch {
          setJobTitle('');
        }
        return;
      }

      if (!orderId || !isAuthenticated() || !token || isTokenExpired(token)) {
        setStatus('auth');
        return;
      }

      try {
        await completePayment(token, orderId, searchParams.get('session_id') || '');
        const orderRes = await getPaymentOrder(token, orderId);
        setJobTitle(orderRes.order?.jobPostingId?.title || '');
        setStatus('review');
      } catch (err) {
        setMessage(err.message);
        setStatus('pending');
      }
    };

    finalize();
  }, [orderId, token, isAuthenticated, searchParams, isFree]);

  return (
    <div className="post-job-page">
      <div className="post-job-container">
        <div className="post-job-card post-job-success-card">
          {status === 'loading' && <p>Confirming your payment...</p>}

          {status === 'auth' && (
            <>
              <h2>Sign in to view your posting status</h2>
              <button className="post-job-btn primary" onClick={() => navigate('/post-job')}>
                Go to Post a Job
              </button>
            </>
          )}

          {status === 'review' && (
            <>
              <div className="post-job-success-icon">✓</div>
              <p className="post-job-eyebrow">Pending Review</p>
              <h2>Pending Review</h2>
              {jobTitle ? (
                <p>
                  <strong>{jobTitle}</strong>
                </p>
              ) : null}
              <p>
                Your job posting has been submitted successfully and is currently under review. It
                typically takes 24–48 hours for approval. You will be notified once your job is
                approved and published.
              </p>
              <div className="post-job-actions center">
                <Link to="/post-job/status" className="post-job-btn primary">
                  View posting status
                </Link>
                <Link to="/post-job" className="post-job-btn secondary">
                  Post another job
                </Link>
              </div>
            </>
          )}

          {status === 'pending' && (
            <>
              <h2>Payment received — pending confirmation</h2>
              <p>{message || 'Your payment is being processed. We will publish your job once confirmed.'}</p>
              <Link to="/contact" className="post-job-btn secondary">
                Contact support
              </Link>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PostJobSuccess;
